import { AxiosResponse } from 'axios';

import Api from './api';

export type MeasurementKey = 'heart_rate' | 'stress' | 'blood_oxygen' | 'heart_rate_variability' | 'weight';

export interface RingLogsBaseParams {
    mac_address?: string;
    device_id?: number;
    start_date?: string;
    end_date?: string;
    page?: number;
    page_size?: number;
}

export interface RingLogsStepsParams extends RingLogsBaseParams {
    interface_key?: string;
}

export interface RingLogsMeasurementsParams extends RingLogsBaseParams {
    measurement_key?: MeasurementKey;
}

export interface RingLogsPageResponse {
    items: any[];
    count: number;
    page: number;
    page_size: number;
}

export const getRingLogSteps = async (
    params: RingLogsStepsParams
): Promise<RingLogsPageResponse> => {
    const response: AxiosResponse<RingLogsPageResponse> = await Api.get(
        '/admin/ring-logs/steps',
        { params }
    );
    return response.data;
};

export const getRingLogSleep = async (
    params: RingLogsBaseParams
): Promise<RingLogsPageResponse> => {
    const response: AxiosResponse<RingLogsPageResponse> = await Api.get(
        '/admin/ring-logs/sleep',
        { params }
    );
    return response.data;
};

export const getRingLogMeasurements = async (
    params: RingLogsMeasurementsParams
): Promise<RingLogsPageResponse> => {
    const response: AxiosResponse<RingLogsPageResponse> = await Api.get(
        '/admin/ring-logs/measurements',
        { params }
    );
    return response.data;
};

export default {
    getRingLogSteps,
    getRingLogSleep,
    getRingLogMeasurements,
};
